module.exports = __webpack_public_path__ + "img/pasture_andropogon_middle.80ed57cf.jpg";